import React from "react";

const BreakLine = ({ style = {} }) => {
  return <hr color="#d6d5d4" className="break-line" style={style}></hr>;
};

export default BreakLine;
